import { gql } from '@apollo/client'

export const GET_MEMBER_BY_DOCUMENT_NUMBER = gql`
  query ($documentNumber: ID!) {
    member(documentNumber: $documentNumber) {
      tier
      total {
        point
        value
      }
      cashback {
        point
        value
        detailByBrand {
          BOT {
            point
            value
          }
          EUD {
            point
            value
          }
          QDB {
            point
            value
          }
        }
      }
      loyalty {
        point
        value
      }
      documentHash
      documentNumber
      documentType
      birthDate
      whatsapp
      gender
      lastPurchase {
        expirationDate {
          point
          value
          date
        }
        valueOfYear
      }
      status
      isBlz
      createdAt
      updatedAt
      givenName
      familyName
      email
      origin {
        originId
        channel
        identifier
      }
      statusChange {
        text
        responsible
        reason
      }
      address {
        postalCode
        streetAddress
        addressNumber
        district
        complement
        addressLocality
        addressRegion
      }
      contacts {
        value
        contactMethod
        contactType
        updatedAt
      }
    }
  }
`
